import React, {Component} from 'react';
import Main from '../Main';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {setLoadingPostUserData, postUserData, postUserDataSuccess, postUserDataError} from '../../actions/UserActions';
import {setLoadingGetRoles, getRoles, getRolesSuccess, getRolesError} from '../../actions/RoleActions';
import { TRANSLATE_YES, TRANSLATE_NO, TRANSLATE_UPLOAD_PHOTO, TRANSLATE_IMAGE_USER, TRANSLATE_CREATE_USER, TRANSLATE_CANCEL, 
    TRANSLATE_ACTIVE, TRANSLATE_PHOTO, TRANSLATE_FIRST_NAME, TRANSLATE_LAST_NAME, TRANSLATE_EMAIL, TRANSLATE_PHONE, TRANSLATE_SAVE, TRANSLATE_ROLE } from '../../translates/Translates';
import { path_users } from '../../routes/Pathnames';
import {Link} from 'react-router-dom';

class CreateUser extends Component{
    constructor(props){
        super(props);

        this.state = {
            user: {
                name: '',
                surname: '',
                email: '',
                phone: '',
                photo: null,
                source: '',
                active: true,
                role: 1
            },
            roles: []
        }
    }

    componentDidMount = () => {
        this.props.setLoadingGetRoles();
        this.props.getRoles().then((response) => {
            this.setState({roles: response.payload.data});
            this.props.getRolesSuccessful();
        }).catch(() => {
            this.props.getRolesError();
        })
    }

    onChangeField = (event) => {
        const value = event.target.value;
        const name = event.target.name;
        this.setState((prevState) => {
            let user = {...prevState.user};
            if(name === "active"){
                if(value === "1"){
                    user[name] = true;
                }else{
                    user[name] = false;
                }
            }else{
                user[name] = value;
            }
            return {
                ...prevState,
                user
            }
        })
    }

    deleteForm = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                user: {
                    name: '',
                    surname: '',
                    email: '',
                    phone: '',
                    photo: null,
                    source: '',
                    active: true,
                    role: 1
                },
            }
        })
    }

    handleFileChange = (event) => {
        if(event.target.files.length > 0){
            let photo = event.target.files[0];
            let reader = new FileReader();
            reader.onload = () => {
                this.setState((prevState) => {
                    let user = {...prevState.user};
                    user.photo = photo;
                    user.source = reader.result;
                    return {
                        ...prevState,
                        user
                    } 
                })
            };
            reader.readAsDataURL(photo);
        }
    }

    submitForm = (userData) => {
        this.props.setLoadingPostUserData();
        this.props.postUserData(userData).then((response) => {
            this.deleteForm();
            this.props.postUserDataSuccess();
        }).catch(() => {
            this.props.postUserDataError();
        })
    }

    render(){
        return(
            <div>
                <Main/>
                <div className="page-wrapper">
                    <div className="container-fluid">
                        <br />
                        <div className="row page-tier3">
                            <div className="col s12">
                                <div className="card card-outline-info">
                                    <div className="card-header">
                                        <h4 className="mb-0 text-white">{TRANSLATE_CREATE_USER}</h4>
                                    </div>
                                    <div className="card-body">
                                        <form method="post">
                                            <div className="form-body">
                                                <div className="row pt-3">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">{TRANSLATE_FIRST_NAME}</label>
                                                            <input type="text" id="name" name="name" className="form-control" value={this.state.user.name} onChange={this.onChangeField} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">{TRANSLATE_LAST_NAME}</label>
                                                            <input type="text" id="surname" name="surname" className="form-control" value={this.state.user.surname} onChange={this.onChangeField} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">{TRANSLATE_EMAIL}</label>
                                                            <input type="email" id="email" name="email" className="form-control" value={this.state.user.email} onChange={this.onChangeField} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">{TRANSLATE_PHONE}</label>
                                                            <input type="text" id="phone" name="phone" className="form-control" value={this.state.user.phone} onChange={this.onChangeField} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">{TRANSLATE_ROLE}</label>
                                                            <select className="form-control custom-select" name="role" value={this.state.user.role} onChange={this.onChangeField}>
                                                                {this.state.roles.map((role) => {
                                                                    return(
                                                                        <option value={role.id} key={role.id}>{role.name}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                            <small className="form-control-feedback"></small>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="form-group mb-2">
                                                            <label className="control-label">{TRANSLATE_ACTIVE}</label>
                                                            <div className="mb-2">
                                                                <label className="custom-control custom-radio">
                                                                    <input name="active" type="radio" value="1" className="custom-control-input" checked={this.state.user.active ? true : false} onChange={this.onChangeField} />
                                                                    <span className="custom-control-label">{TRANSLATE_YES}</span>
                                                                </label>
                                                                <label className="custom-control custom-radio">
                                                                    <input name="active" type="radio" value="0" className="custom-control-input" checked={!this.state.user.active ? true : false} onChange={this.onChangeField} />
                                                                    <span className="custom-control-label">{TRANSLATE_NO}</span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">{TRANSLATE_PHOTO}</label>
                                                            <div className="mb-2">
                                                            {
                                                                this.state.user.source ? (
                                                                    <div className="create-user-photo">
                                                                        <img src={this.state.user.source} className="create-user-photo__img mb-3" alt={TRANSLATE_IMAGE_USER} />
                                                                    </div>
                                                                ) : ''
                                                            }
                                                                <label htmlFor="photo" className="create-user__label-upload btn btn-success mb-3">
                                                                    <span className="text">{TRANSLATE_UPLOAD_PHOTO}</span>
                                                                    <input type="file" id="photo" onChange={this.handleFileChange}/>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6"></div>
                                                </div>
                                            </div>
                                            <div className="form-actions">
                                                <button type="button" className="btn btn-success mr-3" onClick={() => this.submitForm(this.state.user)}> 
                                                    <i className="fa fa-check"></i>&nbsp;{TRANSLATE_SAVE}
                                                </button>
                                                <Link to={path_users} className="btn btn-inverse" >{TRANSLATE_CANCEL}</Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setLoadingPostUserData,
        postUserData,
        postUserDataSuccess,
        postUserDataError,
        setLoadingGetRoles,
        getRoles,
        getRolesSuccess,
        getRolesError
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(CreateUser);
